import AbstractSegment from "./AbstractSegment";

export default class StraightSegment extends AbstractSegment {
    get type() {
        return 'straight';
    }

    display(g) {
        if (this.index === 0) {
            g.vertex(this.start.currentX, this.start.currentY);
        }
        g.vertex(this.end.currentX, this.end.currentY);
    }

    displayHighlight(ctx) {
        if (this.index === 0) {
            ctx.moveTo(this.start.currentX, this.start.currentY);
        }
        ctx.lineTo(this.end.currentX, this.end.currentY);
    }

    displayHover(g) {
        g.line(
            this.start.currentX,
            this.start.currentY,
            this.end.currentX,
            this.end.currentY
        );
    }

    hovered(viewX, viewY, tolerance) {
        const px = viewX, py = viewY;
        const x1 = this.start.currentX, y1 = this.start.currentY;
        const x2 = this.end.currentX, y2 = this.end.currentY;
        const dx = x2 - x1;
        const dy = y2 - y1;
        const lenSq = dx * dx + dy * dy;
        if (lenSq === 0) {
            const d = Math.sqrt((px - x1) * (px - x1) + (py - y1) * (py - y1));
            return d <= tolerance;
        }
        const t = Math.max(0, Math.min(1, ((px - x1) * dx + (py - y1) * dy) / lenSq));
        const projX = x1 + t * dx;
        const projY = y1 + t * dy;
        const d = Math.sqrt((px - projX) * (px - projX) + (py - projY) * (py - projY));
        return d <= tolerance;
    }

    length() {
        return this.start.distanceTo(this.end);
    }

    export(dx, dy) {
        return [this.end.absX + dx, this.end.absY + dy];
    }
}
